import { useQuery } from 'react-query'
import { TreatmentBundle } from '@customTypes/TreatmentBundle'
import { getCategorizedTreatments } from 'src/services/api/treatment'
import { useChoiceState } from '@context/ChoiceContext'
import { useConfig } from '@context/ConfigurationContext'
import { useTreatmentPurpose } from './useTreatmentPurpose'

export const useTreatmentBundleIdForClinic = () => {
  const { treatmentBundleTypeReferenceId, selectedBookableDateAndTime } = useChoiceState()
  const treatmentPurposeId = useTreatmentPurpose()
  const config = useConfig()
  const clinicId = selectedBookableDateAndTime.clinicId || config.clinicId

  const { data: treatments } = useQuery(['categorizedTreatments', clinicId], () => getCategorizedTreatments(clinicId), {
    retry: 3,
    enabled: !!clinicId,
  })

  const findTreatment = (treatmentBundle: Partial<TreatmentBundle>) =>
    treatmentBundle.treatmentPurposeReferenceId === treatmentPurposeId && treatmentBundle.clinicReferenceId === clinicId

  const category = treatments?.find((category) => category.treatmentBundles.some(findTreatment))
  const treatment = category?.treatmentBundles.find(findTreatment)

  return treatment?.referenceId || treatmentBundleTypeReferenceId
}
